import { AddressesHeader } from 'feature/addresses/components/AddressesHeader'
import { RemoveAddressBtn } from 'feature/addresses/components/RemoveAddressBtn'
import { SaveChangesBtn } from 'feature/addresses/components/SaveChangesBtn'
import { selectAddress } from 'feature/addresses/redux/addressCreateSelector'
import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { ModalConfirm } from 'feature/user/components'
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { FC, useEffect, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { AddressSelectInput } from 'widget/AddressSelectInput'

import styles from './AddressSelectForm.module.scss'

interface IAddressSelectForm {
  setViewMode: (arg0: string) => void
  currentEdit: null | SavedAddress
  saveChangesAddress: (arg0: SavedAddress | null) => void
  removeAddress: (arg0: SavedAddress) => void
}

// форма добавления или изменения адреса (для страницы "МОИ АДРЕСА")
export const AddressSelectForm: FC<IAddressSelectForm> = ({
  setViewMode,
  currentEdit,
  saveChangesAddress,
  removeAddress,
}) => {
  const screen = useScreen()
  const [isModalOpen, setModalOpen] = useState<boolean>(false)
  const { setIsValidAddress, setErrorMessage, setIsError, setIsDirtyAddress } =
    useActions()
  const { isError, input, inputSuggest } = useAppSelector(selectAddress)
  const backViewMode = () => {
    setIsValidAddress(false)
    setViewMode('list')
  }

  const openCityPopupHandler = () => {
    if (screen !== ScreenEnum.desktop) {
      setViewMode('popup')
    }
  }

  const onConfirmModal = () => {
    if (!currentEdit) return
    removeAddress(currentEdit)
  }

  const checkIsAddressIsNew = () => {
    if (input === currentEdit?.address) {
      setIsDirtyAddress(false)
    }
  }

  useEffect(() => {
    if (input === currentEdit?.address) {
      setIsError(false)
      setErrorMessage('')
    }
  }, [isError])

  useEffect(() => {
    checkIsAddressIsNew()
  }, [])

  useEffect(() => {
    if (inputSuggest?.address !== input) {
      setIsValidAddress(false)
    }
  }, [input, inputSuggest])

  // если введенный адрес совпадает с исходным
  //деактивирую кнопку
  useEffect(() => {
    checkIsAddressIsNew()
  }, [input])

  return (
    <main className={styles.settingPage}>
      <AddressesHeader showBack={true} backViewMode={backViewMode} />
      <form onSubmit={() => setViewMode('popup')} className={styles.form}>
        <div className={styles.description}>
          Введите адрес, по которому планируете установку изделия. Можете ввести
          вручную или отметить место на карте.
        </div>
        <AddressSelectInput
          className={styles.input}
          onClick={openCityPopupHandler}
          isUserAddressHidden={true}
        />
        <YandexMap
          className={styles.map}
          isDadata
          marks={[MarkType.geolocationMark, MarkType.clickMark]}
          controls={[
            ControlsType.GeolocationControlUnit,
            ControlsType.ZoomControl,
          ]}
        />
      </form>
      <footer className={styles.footer}>
        <SaveChangesBtn
          currentEdit={currentEdit}
          saveChangesAddress={saveChangesAddress}
          text={currentEdit ? 'Сохранить изменения' : 'Добавить адрес'}
        />
        {currentEdit && <RemoveAddressBtn setModalOpen={setModalOpen} />}
      </footer>
      <ModalConfirm
        onConfirm={onConfirmModal}
        cancelText='Отмена'
        actionText='Да'
        modalText='Вы действительно хотите удалить адрес?'
        isModalOpen={isModalOpen}
        onCancel={() => setModalOpen(false)}
      />
    </main>
  )
}
